import React from 'react';
import CreatableSelect from 'react-select/creatable';

import CustomDropdown from '@/components/CustomDropdown';
import CommonImage from '@/components/CommonImage';
const ListCreate = () => {
	return (
		<div className="task-list-create-container mt-3">
			<div className="task-list-create-wrapper">
				{/* single-task-list */}
				<div className="single-task-list mb-3">
					<div className="task-list-header d-flex align-items-center justify-content-between">
						<h3 className="semibold-14 mb-0">Primary settings</h3>
						<div>
							<button className="button outline size32 ml-2">Cancel</button>
							<button className="button size32 ml-2">Update</button>
						</div>
					</div>
					<div className="task-list-create-form mt-3">
						<div className="row">
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="list-title">List title*</label>
									<input type="text" id="list-title" placeholder="Write your list name" />
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="stage">Stage*</label>
									<CustomDropdown
										title="Select customer"
										onItemClick={() => {}}
										selectedItem={''}
										items={[]}
									/>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="stage">Which task can be completed from here</label>
									<CreatableSelect
										isMulti
										value={'TEST'}
										onChange={() => {}}
										options={[]}
										isClearable
									/>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="description">Logic documentation*</label>
									<textarea id="description" rows="4" placeholder="Details"></textarea>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group logic-form-group">
									<textarea placeholder="Write the list logic"></textarea>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* single-task-list */}
				<div className="single-task-list mb-3">
					<div className="task-list-header d-flex align-items-center justify-content-between">
						<h3 className="semibold-14 mb-0">List SOP & tutorials</h3>
					</div>
					<div className="task-list-create-form mt-3">
						<div className="row">
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="list-title">Which styles are you seeing here</label>
									<textarea rows="1" placeholder="Details" />
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="list-title">Summary SOP</label>
									<textarea rows="1" placeholder="Details" />
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="stage">Details SOP file link</label>
									<input type="text" placeholder="Copy-Paste the details SOP link here" />
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="stage">Metabase report link</label>
									<input type="text" placeholder="Copy-Paste the metabase link here" />
								</div>
							</div>
							<div className="col-md-4">
								<div className="tutorial-link">
									<button className="button text size32 px-0">
										<span className="mr-1 semibold-14">Tutorials link</span>
										<CommonImage src="/icons/add-round.svg" alt="add" />
									</button>
									<div className="tutorial-link-list">
										<ul>
											<li className="tutorial-link-item d-inline-block position-relative">
												<p className="title blue weight-400 d-inline-block cursor-pointer w-100 mb-0">
													test link 1
												</p>
												<div className="option position-absolute">
													<div className="dropdown">
														<button
															className="btn btn-default dropdown-toggle"
															type="button"
															id="menu1"
															data-toggle="dropdown"
															aria-expanded="false"
														>
															<img src="/icons/more_icon.svg" alt="" />
														</button>
														<ul
															className="dropdown-menu dropdown-menu-right shadow-lg"
															role="menu"
															aria-labelledby="menu1"
															x-placement="bottom-end"
														>
															<li
																role="presentation"
																className="px-4 pb-3 pt-3"
															>
																<a
																	role="menuitem"
																	tabIndex={-1}
																	className="font-weight-normal  text-black"
																	href="/invoices/edit/10052"
																>
																	Edit
																</a>
															</li>
															<li role="presentation" className="px-4 pb-3">
																<a
																	role="menuitem"
																	tabIndex={-1}
																	className="font-weight-normal  text-black"
																	href
																>
																	Delete
																</a>
															</li>
														</ul>
													</div>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* single-task-list */}
				<div className="single-task-list mb-3">
					<div className="task-list-header d-flex align-items-center justify-content-between">
						<h3 className="semibold-14 mb-0">Others settings</h3>
					</div>
					<div className="task-list-create-form mt-3">
						<div className="row">
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="stage">Status</label>
									<CustomDropdown
										title="Select customer"
										onItemClick={() => {}}
										selectedItem={''}
										items={[]}
									/>
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="stage">Lead time</label>
									<input type="text" placeholder="Input your lead time" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ListCreate;
